import { AddImageIcon, Preloader, TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';

import s from './ScreenSaver.module.scss';

export const renderContent = (
  savedFile: string | null,
  loading: boolean,
  t: TTranslator<TLocalesKeys>,
  fileFormat: string
): JSX.Element => {
  if (loading) return <Preloader loading={loading} />;

  if (!savedFile)
    return (
      <div className={s.placeholder}>
        <AddImageIcon />
        {t('setting.shell.screensaver.placeholder', fileFormat)}
      </div>
    );

  const splitUrl = String(savedFile)?.split('.');
  const extension = splitUrl[splitUrl.length - 1];

  if (extension === 'webm' || extension === 'mp4')
    return (
      <video
        src={savedFile}
        autoPlay
        muted
        loop
        className={s.savedContent}
        width="100%"
        height="100%"
      />
    );

  return <img src={savedFile} alt="shell idle" className={s.savedContent} />;
};
